import { IsDefined, IsNotEmpty, IsString, Length } from 'class-validator';

export class TextConverterToJsonBodyDto {
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Length(1, 10000)
  text: string;
}